import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: 'https://f98dee1f785973c685907374d8b2d991@o4509835098587136.ingest.us.sentry.io/4509835250171909',
    release: `v${import.meta.env.VITE_BUILD_VERSION}_${import.meta.env.VITE_GIT_HASH}`,
    environment: import.meta.env.PROD ? 'production' : 'development',
    enabled: import.meta.env.PROD,
});
